module.exports = __webpack_public_path__ + "img/email-registered.814a93d4.png";